import { createAction } from 'redux-actions';

export const REGISTER_REQUEST = createAction('REGISTER_REQUEST');
export const REGISTER_FAILURE = createAction('REGISTER_FAILURE');
export const REGISTER_SUCCESS = createAction('REGISTER_SUCCESS');
export const REGISTER_RESET_ERROR = createAction('REGISTER_RESET_ERROR');

export const REGISTER_CHECK_EMAIL_RESET = createAction('REGISTER_CHECK_EMAIL_RESET');
